import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const closeDropdown = () => setIsDropdownOpen(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <nav className="bg-blue-700 text-white p-4 shadow-md fixed top-0 w-full z-10">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <button onClick={toggleMobileMenu} className="md:hidden text-white focus:outline-none">
            &#9776;
          </button>
          <div className="hidden md:flex space-x-6 text-lg">
            <Link to="/" className="hover:text-yellow-300">Home</Link>
            <div className="relative">
              <button onClick={toggleDropdown} className="hover:text-yellow-300">Products</button>
              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white text-black shadow-md rounded-md z-20 py-2">
                  <Link to="/order-entry" className="block px-4 py-2 hover:bg-gray-200" onClick={closeDropdown}>Order Entry</Link>
                  <Link
                    to="/prediction"
                    className="block px-4 py-2 hover:bg-gray-200"
                    onClick={closeDropdown}
                  >
                    Prediction
                  </Link>
                </div>

              )}
            </div>
            <Link to="/about" className="hover:text-yellow-300">About Us</Link>
            <Link to="/contact" className="hover:text-yellow-300">Contact Us</Link>
          </div>
        </div>
        <div>
          <Link to="/signin" className="bg-yellow-400 px-4 py-2 rounded hover:bg-yellow-500">Sign In</Link>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-blue-800 p-4 space-y-2">
          <Link to="/" className="block hover:text-yellow-300" onClick={toggleMobileMenu}>Home</Link>
          <Link to="/order-entry" className="block hover:text-yellow-300" onClick={toggleMobileMenu}>Order Entry</Link>
          <Link to="/prediction" className="block hover:text-yellow-300" onClick={toggleMobileMenu}>
            Prediction
          </Link>
          <Link to="/about" className="block hover:text-yellow-300" onClick={toggleMobileMenu}>About Us</Link>
          <Link to="/contact" className="block hover:text-yellow-300" onClick={toggleMobileMenu}>Contact Us</Link>
        </div>
      )}
    </nav>
  );
};

export default Header; 
